import { PositiveFill } from 'ui/icons/status/PositiveFill';
import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { colors } from 'ui/theme/colors';
import { MemberRow } from '../types';
import { TableCell } from './styled';

export const MfaCell = ({ row }: { row: MemberRow }) => (
  <TableCell>
    {row?.tfa ? (
      <PositiveFill color={colors.green100} />
    ) : (
      <NegativeFillDiamond color={colors.iconSubtle} />
    )}
  </TableCell>
);
